  //
  // ボタンをクリックしたらスクロールして上に戻る
  //
function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
}


// 
// ハンバーガーメニュー用のJS
// 
document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".l-header");
  const toggleButton = document.querySelector(".hamburger");
  const navMenu = document.querySelector(".hamburgerNav");
  const menuLinks = header.querySelectorAll("a");

  const setMenuState = (open) => {
    header.classList.toggle("_isOpen", open);
    document.body.classList.toggle("_noScroll", open);
    toggleButton.setAttribute("aria-expanded", open);
    navMenu.setAttribute("aria-hidden", !open);

    // ▼閉じたときのリセット処理
    if (!open) {
      // --- アコーディオンをすべて閉じる ---
      const accordions = header.querySelectorAll('.js-accordionWrap');

      accordions.forEach(accordion => {
        const content = accordion.querySelector('.accordion');

        if (!content) return;

        // 開いてるものだけ閉じる
        if (accordion.classList.contains('_isOpen')) {
          // closeAccordionと同じ挙動
          content.style.height = content.scrollHeight + 'px';

          requestAnimationFrame(() => {
            content.style.height = '0px';
            accordion.classList.remove('_isOpen');
          });
        } else {
          // 念のため完全リセット
          content.style.height = '0px';
        }
      });

      // --- メニューを一番上に戻す ---
      if (navMenu) {
        navMenu.scrollTop = 0;
      }
    }
  };

  // ハンバーガークリック
  toggleButton.addEventListener("click", () => {
    setMenuState(!header.classList.contains("_isOpen"));
  });

  // 外側クリックで閉じる
  document.addEventListener("click", (e) => {
    if (
      !navMenu.contains(e.target) &&
      !toggleButton.contains(e.target)
    ) {
      setMenuState(false);
    }
  });
    
    // ここから任意
       // mvに入ったらクラスをつける
    const mv = document.querySelector(".mv");
    if (!mv) return;

    new IntersectionObserver(
      ([e]) => header.classList.toggle("_inMv", e.isIntersecting)
    ).observe(mv);
    
});

// 同じクラス同士で hover 状態を同期する
document.addEventListener('DOMContentLoaded', () => {
  const areaClasses = [
    'js-mega1',
    'js-mega2',
    'js-mega3',
  ];

  areaClasses.forEach((cls) => {
    const targets = document.querySelectorAll(`.${cls}`);
    if (!targets.length) return;

    const add = () => targets.forEach((el) => el.classList.add('_isHover'));
    const remove = () => targets.forEach((el) => el.classList.remove('_isHover'));

    targets.forEach((el) => {
      el.addEventListener('mouseenter', add);
      el.addEventListener('mouseleave', remove);

      // キーボード操作でも同じ挙動にしたい場合（任意）
      el.addEventListener('focusin', add);
      el.addEventListener('focusout', remove);
    });
  });
});

// 
// MVの画像切り替え
// 
document.addEventListener('DOMContentLoaded', () => {
  const containers = Array.from(document.querySelectorAll('.js-imgChange'));
  if (!containers.length) return;

  // CSS変数を読むヘルパ
  const parseTime = (v) => {
    const s = (v || '').trim();
    if (s.endsWith('ms')) return parseFloat(s);
    if (s.endsWith('s'))  return parseFloat(s) * 1000;
    const n = Number(s);
    return Number.isFinite(n) ? n : 0;
  };
  const root = getComputedStyle(document.documentElement);
  const HOLD = parseTime(root.getPropertyValue('--hold')) || 9000; // 既定5s
  const FADE = parseTime(root.getPropertyValue('--fade')) || 2000; // 既定1s
  const CROSS_START = Math.max(0, HOLD - FADE); // 4秒（5s-1s）

  // インスタンス管理
  const instances = new WeakMap();

  const isVisible = (el) => getComputedStyle(el).display !== 'none';

  const createInstance = (container) => {
    const images = Array.from(container.querySelectorAll('img'));
    if (images.length <= 1) return null;

    let currentIndex = images.findIndex(img => img.classList.contains('_opacity'));
    if (currentIndex === -1) {
      currentIndex = 0;
      images[currentIndex].classList.add('_opacity');
    }

    let t1 = null, t2 = null, running = false;

    const start = () => {
      if (running) return;
      running = true;

      // 初回：確実にトランジションを発火
      images[currentIndex].getBoundingClientRect();
      requestAnimationFrame(() => {
        images[currentIndex].classList.add('_scale');
        loop();
      });
    };

    const stop = () => {
      running = false;
      if (t1) clearTimeout(t1);
      if (t2) clearTimeout(t2);
      t1 = t2 = null;
    };

    const loop = () => {
      if (!running) return;

      const current = images[currentIndex];
      const nextIndex = (currentIndex + 1) % images.length;
      const next = images[nextIndex];

      // 4秒後：次の画像フェードイン＆スケール開始、現行はフェードアウト
      t1 = setTimeout(() => {
        if (!running) return;
        next.getBoundingClientRect();
        next.classList.add('_opacity', '_scale');
        current.classList.remove('_opacity');
      }, CROSS_START);

      // 5秒後：切替確定 → 次サイクル
      t2 = setTimeout(() => {
        if (!running) return;
        current.classList.remove('_scale'); // 後片付け
        currentIndex = nextIndex;
        loop();
      }, HOLD);
    };

    return { start, stop, isRunning: () => running };
  };

  // すべてのコンテナにインスタンス用意
  containers.forEach((c) => {
    const inst = createInstance(c);
    if (inst) {
      instances.set(c, inst);
      if (isVisible(c)) inst.start();
    }
  });

  // リサイズでPC/SPの表示が切り替わったら、可視のものだけ動かす
  let resizeTimer = null;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      containers.forEach((c) => {
        const inst = instances.get(c);
        if (!inst) return;
        const vis = isVisible(c);
        if (vis && !inst.isRunning()) inst.start();
        if (!vis && inst.isRunning()) inst.stop();
      });
    }, 100);
  });
});

// 
// アコーディオン
// 
document.querySelectorAll('.js-accordionWrap').forEach(accordion => {
  const buttons = accordion.querySelectorAll('.accordion-btn');
  const content = accordion.querySelector('.accordion');

  // アニメーション後、autoに切り替える（動的対応のため）
  content.addEventListener('transitionend', () => {
    if (accordion.classList.contains('_isOpen')) {
      content.style.height = 'auto'; // ←ここがキモ
    }
  });

  const openAccordion = () => {
    // 1. 一度 height を auto にして、scrollHeight を正確に取得
    content.style.height = 'auto';
    const height = content.scrollHeight + 'px';

    // 2. 一度リセットしてからアニメーション用に数値を代入
    content.style.height = '0px'; // ← これがないと transition 効かない
    requestAnimationFrame(() => {
      content.style.height = height;
    });

    accordion.classList.add('_isOpen');
  };

  const closeAccordion = () => {
    // 1. 固定値にしてアニメーション
    content.style.height = content.scrollHeight + 'px';

    // 2. 直後に 0 に戻す
    requestAnimationFrame(() => {
      content.style.height = '0px';
      accordion.classList.remove('_isOpen');
    });
  };

  buttons.forEach(button => {
    button.addEventListener('click', e => {
      e.preventDefault();

      // data-scroll-target がある場合はスクロール
const scrollTarget = button.getAttribute('data-scroll-target');
if (scrollTarget) {
  const targetElement = document.querySelector(scrollTarget);
  if (targetElement) {
    const offset = 80; // 画面上から80px下げる
    const elementRect = targetElement.getBoundingClientRect();
    const elementTop = elementRect.top + window.pageYOffset;
    window.scrollTo({
      top: elementTop - offset, // 80px上にスクロール
      behavior: 'smooth'
    });
  }
}

      // アコーディオンの開閉
      if (accordion.classList.contains('_isOpen')) {
        closeAccordion();
      } else {
        openAccordion();
      }
    });
  });

  // 初期化
  content.style.height = '0';
});

// 
// 要素が画面に入ったら　シンプル
// 
document.addEventListener('DOMContentLoaded', () => {
  const elements = document.querySelectorAll('.js-maskAnim');

  function onScroll() {
    const windowHeight = window.innerHeight;

    elements.forEach(el => {
      const rect = el.getBoundingClientRect();

      // 少しでも画面に入ったら　切り替え不要ならelse{}を消す
      if (rect.top < windowHeight && rect.bottom > 0) {
        el.classList.add('_isActive');
      } else {
        el.classList.remove('_isActive');
      }
    });
  }

  window.addEventListener('scroll', onScroll);
  window.addEventListener('resize', onScroll);
  onScroll(); // 初回判定
});

//
// ホバーで離れた位置の画像を変える
// 
document.querySelectorAll('.js-hoverChange').forEach(section => {
  const links = section.querySelectorAll('.hoverItem[data-key]');
  const imgs  = section.querySelectorAll('.changeImg[data-key]');

  const showByKey = key => {
    imgs.forEach(img => {
      img.classList.toggle('_isActive', img.dataset.key === key);
    });
  };

  // ホバー時に画像切り替え
  links.forEach(link => {
    const key = link.dataset.key;
    link.addEventListener('mouseenter', () => showByKey(key));
    link.addEventListener('focus', () => showByKey(key)); // アクセシビリティ
  });

  // セクションからマウス離れたら default に戻す
  section.addEventListener('mouseleave', () => showByKey('default'));
});

// 
// タブのJS
// 
document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".c-tabs");
  
      // .c-tabsが存在しない場合は早期リターン
    if (tabs.length === 0) return;


    tabs.forEach(tabContainer => {
        const buttons = tabContainer.querySelectorAll(".c-tabs-btn");
        const contents = tabContainer.querySelectorAll(".c-tabs-cont");

        buttons.forEach(button => {
            button.addEventListener("click", () => {
                // 全てのボタンとコンテンツを非アクティブ化
                buttons.forEach(btn => btn.classList.remove("_active"));
                contents.forEach(content => content.classList.remove("_active"));

                // 対応するタブをアクティブ化
                button.classList.add("_active");
                const tabId = button.dataset.tab;
                tabContainer.querySelector(`#${tabId}`).classList.add("_active");
            });
        });
    });
});

//
// 複数対応スプライド　最低限（安全版）
//
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-splide .splide').forEach((el) => {
    new Splide(el, {
     	type: 'loop', // ← 無限ループに変更
			perPage: 2,
      focus: "center",
			perMove: 1, // ← 1回で移動する数
      gap: '24px',
      autoplay: true,
      interval: 3000,
      speed: 1000,
      pauseOnFocus: false,
			arrows: true,
			pagination: true,
      breakpoints: {
        768: {
          perPage: 1,
        },
      },
    }).mount();
  });
});


// 
// クリックした画像に切り替える、複数対応
// 
const setupImageSwitchers = () => {
    const switchers = document.querySelectorAll('.js-imgSwitch');
    if (switchers.length === 0) return;

    switchers.forEach(switcher => {
        const bigImg = switcher.querySelector('.bigImg img');
        const smallImgs = switcher.querySelectorAll('.smallImg img');
        if (!bigImg || smallImgs.length === 0) return;

        smallImgs.forEach(img => {
            img.addEventListener('click', () => {
                if (bigImg.src === img.src) return;

            bigImg.style.opacity = 0;

            const changeImage = () => {
                    bigImg.src = img.src;
                    bigImg.style.opacity = 1;
                };

                // トランジションが完了したら画像を切り替え
                bigImg.addEventListener('transitionend', changeImage, { once: true });
            });
        });
    });
};

setupImageSwitchers();


// 
// 要素50%をこえたらクラスを外す
// 
document.addEventListener('DOMContentLoaded', function () {
  const target = document.querySelector('.l-fixLink');
  const footer = document.querySelector('.footerCta');

  function handleScroll() {
    if (!target || !footer) return;

    const footerRect = footer.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // footer要素が画面の50%の高さを超えたら
    if (footerRect.top < windowHeight * 0.8) {
      target.classList.add('_isHidden');
    } else {
      target.classList.remove('_isHidden');
    }
  }

  // スクロール時に実行
  window.addEventListener('scroll', handleScroll);
});


document.addEventListener("DOMContentLoaded", function () {

const form = document.querySelector(".c-form");

  // formが存在しない場合、早期リターン
  if (!form) return;

  const checkbox = form.querySelector('input[name="acceptance-privacy"]');

  // checkboxが存在しない場合、早期リターン
  if (!checkbox) return;

  const submit = form.querySelector('input[type="submit"]');

  // submitボタンが存在しない場合、早期リターン
  if (!submit) return;

  // エラーメッセージ作成
  const error = document.createElement("p");
  error.className = "privacy-error";
  error.textContent = "プライバシーポリシーへの同意が必要です";
  error.style.color = "red";
  error.style.display = "none";

  checkbox.parentNode.appendChild(error);

  form.addEventListener("submit", function(e) {

    if (!checkbox.checked) {
      e.preventDefault();
      error.style.display = "block";
    } else {
      error.style.display = "none";
    }

  });

});



// 
// 選択項目によって入力項目を非表示
// 
document.addEventListener('DOMContentLoaded', function () {

  const targets = document.querySelectorAll('.js-hiddenTarget');

  function hideTargets(){
    targets.forEach(function(target){

      target.classList.add('_isHidden');

      const inputs = target.querySelectorAll('input, textarea, select');

      inputs.forEach(function(input){
        input.required = false;
      });

    });
  }

  function showTargets(){
    targets.forEach(function(target){

      target.classList.remove('_isHidden');

      const inputs = target.querySelectorAll('input, textarea, select');

      inputs.forEach(function(input){
        input.required = true;
      });

    });
  }

  // -----------------------------
  // 入力画面（radio）
  // -----------------------------
  const radios = document.querySelectorAll('.js-hiddenChoice input');

  if(radios.length){
    radios.forEach(function(radio){
      radio.addEventListener('change', function(){

        if(this.value.includes("採用について")){
          hideTargets();
        }else{
          showTargets();
        }

      });
    });
  }else { // ラジオボタンが存在しない場合

  // -----------------------------
  // 確認画面（span）
  // -----------------------------
  setTimeout(function(){

    const confirmText = document.querySelector('.js-hiddenChoice span');

    if(confirmText){

      const text = confirmText.textContent;

      if(text.includes("採用について")){
        hideTargets();
      }else{
        showTargets();
      }

    }

  }, 300);
  }
});


document.addEventListener('DOMContentLoaded', function () {

  const form = document.querySelector('.c-form');

  // formが存在しない場合は早期リターン
  if (!form) return;

  const submitBtn = form.querySelector('.wpcf7-submit');

  // submitBtnが存在しない場合は早期リターン
  if (!submitBtn) return;



  submitBtn.addEventListener('click', function(e){

    const requiredFields = form.querySelectorAll('input[required], textarea[required], select[required]');
    let hasError = false;

    requiredFields.forEach(function(field){

      const value = field.value.trim();

      // 既存エラーメッセージ削除
      const oldError = field.parentNode.querySelector('.js-error');
      if(oldError){
        oldError.remove();
      }

      if(!value){

        hasError = true;
        field.classList.add('is-error');

        const error = document.createElement('p');
        error.className = '_isError';
        error.textContent = '入力してください。';

        field.parentNode.appendChild(error);

      }else{

        field.classList.remove('is-error');

      }

    });

    if(hasError){
      e.preventDefault();
    }

  });

});